export default "__VITE_ASSET__8IzIYnUS__"